import { Component, h, Event, EventEmitter, Listen, State, Host } from '@stencil/core';


@Component({
  tag: 'tambr-auth',
  styleUrl: 'tambr-auth.css',
  shadow: true,
})
export class TambrAuth {

  @Event() tambrAuthClose: EventEmitter;

  @State() formType: 'login' | 'signup' | 'reset' = 'login';

  @Listen('tambrChangeLoginForm') changeLoginFormHandler( event: CustomEvent<'login' | 'signup' | 'reset'> ) {
    this.formType = event.detail;
  }

  close() { this.tambrAuthClose.emit(); }
  
  render() {
    return (
      <Host id="tambr-auth" class="tambr-modal-window login-window">

        <div class="tambr-modal-header">
          <tambr-icon type="close" class="close-button" onClick={ () => this.close() } />
        </div>

        <div class="tambr-modal-title">{ this.renderTitle() }</div>

        <div class="tambr-modal-body">{ this.renderForm() }</div>
          
      </Host>      
    );
  }

  renderTitle() {
    switch ( this.formType ) {
      case 'login': return ( 'Login' );
      case 'signup': return ( 'Sign up' );
      case 'reset': return ( 'Reset Password' );
    }
  }

  renderForm() {    
    switch ( this.formType ) {
      case 'login': return ( <tambr-auth-login /> );
      case 'signup': return ( <tambr-auth-signup /> );
      case 'reset': return ( <tambr-auth-password-reset /> );
    }
  }

}
